<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Acknowledgements</p>
<p class="noindent">Special thanks to Richard Allen, Polly Ayre, Stephen Bennett, A.J. Downing, Timothy Dwight, Ralph W. Emerson, Enhanced Computers, J.S. Crane, John Flanders, Sam W. Foss, Watson Glider, Starr King, R.J. McGinnis, Kathy Melanson, Arthur Page, Theodore Parker, John Spargo, Charles Robinson, William F. Robinson, Frederick Tudor, Patricia Welch and John G. Whittier.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?4a5f9ff6